<template>
  <el-form
    :model="card_class_info"
    ref="cardClassRef"
    :rules="cardClassRules"
    label-width="180px"
    label-position="right"
    style="padding:20px 0 20px 0"
  >
    <el-form-item label="店铺logo：" style="height:100px" prop="log_pic_url">
      <logo
        :wh="'height:100px;width:100px;background-color:#80c4ff;font-size:20px'"
        :tag="'logo'"
        @getReturn="getReturn"
        @returnClose="returnClose"
      >
        LOGO
      </logo>
      <pre style="display:inline-block;margin-left:110px;margin-top:-10px;">
        1、大小需为120像素*120像素。
        2、支持JPG/JPEG/PNG格式，且图片小于1M。
        3、可以不上传
      </pre>
    </el-form-item>
    <el-form-item label="店铺id：" style="margin-top:50px;">
      <el-input v-model="card_class_info.merchant_id"></el-input>
    </el-form-item>
    <el-form-item label="微信卡id：">
      <el-input v-model="card_class_info.wx_card_id"></el-input>
      <span style="display:inline-block;margin-left:20px">
        绑定微信卡id（暂时可以不填）
      </span>
    </el-form-item>
    <el-form-item label="卡分类名称：" prop="classify_name">
      <el-input v-model="card_class_info.classify_name"></el-input>
      <span style="display:inline-block;margin-left:20px">
        设置分类名称
      </span>
    </el-form-item>

    <el-form-item label="绑定标识：">
      <!-- <el-input v-model="card_class_info.binds_flag "></el-input> -->
      <el-switch
        v-model="card_class_info.binds_flag"
        active-text="支持转让"
        inactive-text="不支持转让"
      >
      </el-switch>
      <span style="display:inline-block;margin-left:20px">
        会员卡是否可以转让，一旦设定无法修改
      </span>
    </el-form-item>
    <el-form-item label="是否支持积分："
      ><el-radio-group v-model="card_class_info.supply_bonus">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
      <span style="display:inline-block;margin-left:20px">
        设置该类型的优惠卷是否支持积分功能。
      </span>
    </el-form-item>
    <el-form-item label="是否支持储值："
      ><el-radio-group v-model="card_class_info.supply_balance">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
      <span style="display:inline-block;margin-left:20px">
        设置该类型的优惠卷是否支持储值功能。
      </span>
    </el-form-item>
    <el-form-item label="分类描述：" prop="detail">
      <el-input
        type="textarea"
        :rows="4"
        style="width:300px"
        v-model="card_class_info.detail"
      ></el-input>
      <br />
      <!-- <span style="display:inline-block;margin-left:20px">
        注：如示例，用于介绍会员卡注意点。
      </span> -->
    </el-form-item>
    <el-form-item label="特权说明：" prop="prerogative">
      <el-input
        type="textarea"
        :rows="4"
        style="width:300px;display:inline-block"
        v-model="card_class_info.prerogative"
      ></el-input>
      <br />
      <!-- <span style="display:inline-block;margin-left:20px;">
        注：如示例，用于介绍会员卡使用提示。
      </span> -->
    </el-form-item>
    <el-form-item label="背景图片：" prop="backgroup_pic">
      <logo
        :wh="
          'height:160px;width:288.9px;background-color:#80c4ff;font-size:20px;'
        "
        :tag="'bg'"
        @getReturn="getReturn"
        @returnClose="returnClose"
      >
        <div style="height:160px;width:288.9px'">
          上传背景图
        </div>
      </logo>
    </el-form-item>
  </el-form>
</template>
<script>
import logo from "@/components/logo.vue";
import { classifyGenerate } from "@/api/index";
export default {
  name: "ccf",
  data() {
    return {
      card_class_info: {
        classify_name: "测试", //分类名称
        detail: "测试", //分类描述
        wx_card_id: "测试", //微信会员卡ID
        log_pic_url: "", // LOG的地址长度: 32需要用上传图片接口上传返回的32位数值
        backgroup_pic: "", //_url 背景图片的地址 需要用上传图片接口上传返回的32位数值
        supply_balance: true, // 支持储值0-不支持 非0-支持积分功能 长度1位
        supply_bonus: true, //支持积分0-不支持 非0-支持储值功能 长度1位
        prerogative: "测试", //特权说明会员卡的说明例如：
        binds_flag: false
      },
      cardClassRules: {
        classify_name: [
          { required: true, message: "请输入类别名称", trigger: "blur" }
        ],
        log_pic_url: [
          { required: true, message: "请上传店铺logo", trigger: "blur" }
        ],
        backgroup_pic: [
          { required: true, message: "请上传背景图片", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  components: {
    logo
  },
  mounted() {},
  methods: {
    //上传图片返回
    getReturn(res) {
      console.log("返回值", res);
      switch (res.tag) {
        case "logo":
          this.card_class_info.log_pic_url = res.media_no;
          break;
        case "thumbnail":
          break;
        case "bg":
          this.card_class_info.backgroup_pic = res.media_no;
          break;
      }
    },
    //删除图片返回
    returnClose(res) {
      switch (res.tag) {
        case "tag":
          this.card_class_info.log_pic_url = "";
          break;
        case "thumbnail":
          this.card_class_info.img_thumbnail = "";
          break;
        case "bg":
          this.card_class_info.backgroup_pic = "";
          break;
      }
    },
    getDate(date, str) {},
    createCardClass() {
      this.$refs.cardClassRef.validate(async result => {
        if (result === true) {
          const res = await classifyGenerate(this.card_class_info);
          console.log("创建卡类别返回：", res);
        }
      });
    }
  }
};
</script>
<style scoped>
.el-form {
  color: #9d9fa5;
}
#date-div >>> .el-input {
  width: 200px !important;
}
.el-form-item >>> .el-input {
  width: 300px !important;
}
.el-divider--horizontal {
  height: 0.1px;
  margin-top: 5px !important;
  margin-right: 30px !important;
  margin-bottom: 0 !important;
}
.el-form-item__error {
  top: 120px;
}
</style>
